import {
  BaseFormElementData,
  BaseFormElementModel,
  BaseFormElementSettingsData,
  BaseFormElementState
} from '@/components/addons/registration/BaseFormElementModel';
import { IntegrationRecaptchaModel } from '@/components/integrations/recaptcha/Model';
import store from '@/store';

export type FormElementCaptchaSettingsData = BaseFormElementSettingsData;

export interface FormElementCaptchaData extends BaseFormElementData {
  settings?: FormElementCaptchaSettingsData;
}

export type FormElementReCaptchaValue = {
  valid: string;
};

export type FormElementReCaptchaState = BaseFormElementState<string>;

export class FormElementReCaptchaModel extends BaseFormElementModel<
  string,
  FormElementCaptchaData,
  FormElementReCaptchaState
> {
  // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
  parseFormElement(data: FormElementCaptchaData) {
    // No settings available we need to handle;
  }

  public getSiteKey() {
    const campaignState = store.getters['campaign/state'];
    const recaptchaIntegrationModel = campaignState.config?.integrations.find((integration) => {
      if (integration.state.namespace === 'recaptcha') {
        return integration;
      }
    }) as IntegrationRecaptchaModel;
    if (recaptchaIntegrationModel) {
      return recaptchaIntegrationModel.state.recaptchaSiteKey;
    }
  }

  getInitialValue(): undefined {
    return undefined;
  }

  parseStringValue(): undefined {
    return undefined;
  }

  getSerializedPostValue(): FormElementReCaptchaValue | string {
    return this.state.value ?? '';
  }

  getStringifiedValue(): string | undefined {
    return this.state.value && this.state.value !== '' ? this.state.value : undefined;
  }

  getSerializedCookieValue(): string {
    return typeof this.state.value === 'object' ? JSON.stringify(this.state.value) : '';
  }

  getValidationRules(): string[] {
    const rules = super.getValidationRules();

    if (!rules.includes('required')) {
      rules.push('required');
    }

    return rules;
  }

  authorSignature(): string {
    return 'Nicky Christensen';
  }
}
